import { IClassname } from '@/lib/shared/model/classname';

export const StaffRoom = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14276_573)">
        <path
          d="M23.6675 21.7604V16.0098"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.4727 30.7059V22.3994"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4442 18.5107C14.2292 18.3984 14.9798 18.1144 15.6425 17.6788C16.3051 17.2432 16.8635 16.6668 17.2779 15.9906V29.1085C17.2789 29.5318 17.4475 29.9375 17.7469 30.2369C18.0462 30.5362 18.452 30.7048 18.8753 30.7059H22.0701C22.4934 30.7048 22.8992 30.5362 23.1985 30.2369C23.4979 29.9375 23.6665 29.5318 23.6675 29.1085V21.441C23.6675 21.8646 23.8358 22.2709 24.1354 22.5705C24.4349 22.8701 24.8412 23.0384 25.2649 23.0384C25.6885 23.0384 26.0948 22.8701 26.3944 22.5705C26.694 22.2709 26.8623 21.8646 26.8623 21.441V15.3709C26.8623 14.3541 26.4584 13.379 25.7394 12.66C25.0204 11.941 24.0453 11.5371 23.0285 11.5371H18.5379C17.7661 11.5375 17.0097 11.7529 16.3535 12.1592C15.6974 12.5655 15.1674 13.1466 14.823 13.8374L14.6722 14.1402C14.4864 14.51 14.2014 14.8209 13.8492 15.0382C13.497 15.2555 13.0913 15.3707 12.6774 15.3709H6.73509C6.31144 15.3709 5.90513 15.5392 5.60556 15.8387C5.30599 16.1383 5.1377 16.5446 5.1377 16.9683C5.1377 17.3919 5.30599 17.7982 5.60556 18.0978C5.90513 18.3974 6.31144 18.5657 6.73509 18.5657H8.33249"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4442 15.2354V22.3994C13.4442 22.7383 13.3095 23.0633 13.0699 23.303C12.8302 23.5426 12.5052 23.6773 12.1663 23.6773H9.61044C9.27151 23.6773 8.94647 23.5426 8.70681 23.303C8.46716 23.0633 8.33252 22.7383 8.33252 22.3994V15.3708"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.2778 5.14746V5.78642C17.2778 6.63373 17.6144 7.44634 18.2136 8.04548C18.8127 8.64462 19.6253 8.98121 20.4726 8.98121C21.3199 8.98121 22.1325 8.64462 22.7317 8.04548C23.3308 7.44634 23.6674 6.63373 23.6674 5.78642V5.14746"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6674 5.14724H17.2778V2.40611C17.2774 2.27224 17.3183 2.14149 17.3949 2.03171C17.4715 1.92193 17.5801 1.83847 17.7059 1.79271C19.4951 1.15373 21.4502 1.15373 23.2393 1.79271C23.3651 1.83847 23.4737 1.92193 23.5504 2.03171C23.627 2.14149 23.6679 2.27224 23.6674 2.40611V5.14724Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14276_573">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.00976562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
